import {api} from './api'
import {ApiResponse, ExchangeRate} from '../types'

export const getExchangeRates = async (): Promise<ExchangeRate[]> => {
    try {
        const response = await api.get<ApiResponse<ExchangeRate[]>>('/api/admin/exchange-rates')
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching exchange rates:', error)
        return []
    }
}

export const updateExchangeRate = async (code: string, rate_lbp: number): Promise<boolean> => {
    try {
        const response = await api.post('/api/admin/exchange-rates/update', {code, rate_lbp})
        return response.data.success
    } catch (error) {
        console.error('Error updating exchange rate:', error)
        return false
    }
}